import bemBlock from '@gik/core/utils/bemBlock';
import { Button } from '@gik/ui-legacy/Button';
import type React from 'react';

const blockName = 'saved-items';

export interface ISavedItemsProps {
  sectionTitle: string;
  buttonTitle: string;
  buttonPrepend: React.ReactNode;
  buttonLink: string;
}

export default function SavedItems({
  sectionTitle,
  buttonTitle,
  buttonPrepend,
  buttonLink,
  children,
}: React.PropsWithChildren<ISavedItemsProps>) {
  const bem = bemBlock(blockName);

  return (
    <section className={bem()}>
      <div className={bem('title')}>{sectionTitle}</div>
      {children}
      <Button className={bem('button')} type="a" href={buttonLink} variant="primary" prepend={buttonPrepend}>
        {buttonTitle}
      </Button>
    </section>
  );
}
